import useCoreStore from "views/hooks/useCoreStore";
import { useTranslation } from "react-i18next";
import { FaArrowRight } from "react-icons/fa";
import SalesAccounts from "./SalesAccounts";
import { Button, Row, Col } from "antd";
import SalesVAT from "./SalesVAT";
import React from "react";

interface BreakdownsPropsTypes {
  nextButton?: () => void;
  prevButton?: () => void;
}
export default function Sales(props: BreakdownsPropsTypes): React.ReactElement {
  const { nextButton } = props;
  const { t } = useTranslation();
  const companySettings = useCoreStore(state => state.companySettings);

  const counterpartProductAllocationType = companySettings?.counterpartProductAllocationType?.value;
  const counterpartByCategory = counterpartProductAllocationType === "by_category";
  return (
    <>
      <Row gutter={16}>
        {!counterpartByCategory && (
          <Col span={12}>
            <SalesAccounts />
          </Col>
        )}
        <Col span={!counterpartByCategory ? 12 : 24}>
          <SalesVAT />
        </Col>
      </Row>

      {nextButton && (
        <Row justify="end">
          <Button
            type="primary"
            className="save-btn"
            onClick={() => nextButton()}
            icon={<FaArrowRight />}
          >
            {t("Next")}
          </Button>
        </Row>
      )}
    </>
  );
}
